import { useRouter } from 'next/router'

import GET_COLLECTION_CREATORS from '@/graphql/queries/creators/getCollectionCreators'
import GET_SEARCH_FILTERS from '@/graphql/queries/global/getSearchFilters'
import useHasura from '@/hooks/useHasura'
import Creator from '@/ts/Creator'
import ProductType, {
  ProductTypeAsTitleMap,
} from '@/ts/enums/product/ProductType'
import FilterGroup from '@/ts/interfaces/global/FilterGroup'

function useStaticProducts({
  staticFilters,
  staticCreators,
}: UseStaticProductsProps) {
  const {
    query: { q },
  } = useRouter()

  const config = { initialData: staticFilters }
  const variables = {
    search: `%%${q ?? ''}%%`,
  }

  const filtersQuery = useHasura<FilterGroup>('filters', GET_SEARCH_FILTERS, {
    config,
    variables,
  })

  const collectionCreatorsQuery = useHasura(
    'collection_creators',
    GET_COLLECTION_CREATORS,
    {
      config: {
        enabled: false,
        initialData: staticCreators,
      },
    }
  )

  const filters = filtersQuery.data
  const creators = collectionCreatorsQuery.data?.creators

  return {
    filters: {
      ...filters,
      ...(filters?.type && {
        type: filters.type?.map(({ id }) => ({
          id,
          name: ProductTypeAsTitleMap[id as ProductType],
        })),
      }),
    },
    creators,
  }
}

interface UseStaticProductsProps {
  staticCreators?: {
    creators: Creator[]
  }
  staticFilters?: FilterGroup
  withCollections?: boolean
  onlyCreators?: boolean
  productType?: ProductType
}

export default useStaticProducts
